// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: auto;
  padding: 0;
}

html, body {
  height: 100%;
}

body {
  background-color: rgba(0,0,0,1);
  color: #eee;
  font-family: Helvetica, Arial;
  font-size: 3vmin;
}

footer {
  background-color: rgba(0,0,0,1) !important;
  color: #eee !important;
  font-family: Helvetica, Arial !important;
  font-size: calc(10px + 2vmin) !important;
  border-top: 2px solid #eee !important;
  padding: 2vw !important;
  max-width: 100% !important;
}

.App {
  text-align: center;
}

.App-logo {
  pointer-events: none;
  width: 150px;
}

.App-header {
  background-color: rgba(0,0,0,1);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.smSpotifyLogo {
  width: 17vw;
}

.lgSpotifyLogo {
  width: 22vw;
}

textarea {
  height: 40vw !important;
  width: 40vw !important;
  font-size: 2vw !important;
  vertical-align:text-top !important;
  margin-right: 5vw !important; 
}

input {
  width: 40vw !important;
  font-size: 2vw !important;
  vertical-align:text-top !important;
}

.hidden {
  display: none;
}

/** Buttons **/

.btn {
  background-color: transparent !important;
  border-radius: 2em !important;
  border: 0.2em solid rgb(0,196,85) !important;
  color: rgb(0,196,85) !important;
  cursor: pointer !important;
  font-size: 3vmin !important;
  padding: 1em 1.5em !important;
  text-transform: uppercase !important;
  transition: all 0.25s ease !important;
  text-decoration: none !important;
  font-weight: 700 !important;
  min-height: 50px !important;
  outline: none;
}

.btn:hover .audio-control-icon,
.btn:active .audio-control-icon {
  fill: black;
}

.btn-non-controls {
  background-color: transparent !important;
  border-radius: 2em !important;
  border: 0.2em solid rgb(0,196,85) !important;
  color: rgb(0,196,85) !important;
  cursor: pointer !important;
  font-size: 3vmin !important;
  text-transform: uppercase !important;
  transition: all 0.25s ease !important;
  text-decoration: none !important;
  font-weight: 700 !important;
  min-height: 50px !important;
  margin: 1em 1em !important;
}

.btn-sm {
  font-size: 2vmin !important;
  margin: 0 !important;
}

.btn:hover {
  background: rgb(0,196,85) !important;
  color: rgba(0,0,0,0.8) !important;
  font-weight: 700 !important;
}

.favoriteBtnDiv {
  padding: 2vw;
  padding-right: 5vw;
}

.favoriteBtn {
  width: 8vw;
  cursor: pointer;
}

.cocktailPairingDiv {
  position: relative;
  padding: 5vw 0 0 20vw;
  width: 47vw;
  float: left;
  text-align: center;
}

#curCocktailDivGroup {
  width: 100% !important;
}

#navlink-login-btn {
  display: table-cell !important;
  vertical-align:middle !important;
  height: 50px !important;
  width: 218px !important;
}

#navlink-login-btn:hover {
  background: rgb(0,196,85) !important;
  color: rgba(0,0,0,0.8) !important;
  font-weight: 700 !important;
}

/** Background **/

.background {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center center;
  filter: blur(8em) opacity(0.6);
}

.main-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  margin: 0 auto;
  justify-content: center;
  position: relative;
  width: 80%;
  z-index: 1;
  font-size: 0.7em;
}

.container {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
}

.main-container {
  flex: 1 1;
}

/** Player CSS **/
/** Now Playing **/
.now-playing {
  max-width: 500px;
}

.now-playing__name {
  font-size: 1.5em;
  margin-bottom: 0.2em;
}

.now-playing__artist {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.now-playing__device-select {
  font-size: 1.2em;
  margin-bottom: 0.25em;
}
.now-playing__device-select select {
  width: 35vw;
  cursor: pointer;
}

.now-playing__status {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.now-playing__img {
  float: left;
  margin-right: 10px;
  text-align: right;
  width: 45%;
}

.now-playing__img img {
  min-width: 20vmin;
  max-width: 80vmin;
  width: 100%;
}

.now-playing__side {
  margin-left: 5%;
  width: 45%;
}

/** Progress Bar **/

.progress {
  border: 1px solid #eee;
  height: 6px;
  width: 35vw;
  /* margin: 0; */
  margin-left: 0.5vw;
  border-radius: 3px;
  overflow: hidden;
}

.progress__bar {  
  background-color: rgba(0,0,0,0.8);
  height: 16px;
  margin: 0;
}


/** Navbar Styling **/

NavbarBrand {
  vertical-align: bottom;
}

#artist-search {
  min-width: 34vh !important;
  display: inline !important;
}

.search-form {
  display: inline !important;
}

#search-submit {
  width: 100%;
}

/** Text box styling **/

.normal-text {
  max-width: 575px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

h3 {
  margin: 7vh !important;
}


/** Cocktail styling **/

.cocktail__img {
  float: right;
  margin-left: 10px;
  text-align: left;
  width: 45%;
}

.cocktail__img img {
  min-width: 20vmin;
  max-width: 80vmin;
  width: 100%;
}

.cocktail__directions {
  white-space: pre-wrap !important;
  margin-bottom: 0.2em;
}

.cocktail__side {
  margin-left: 5%;
  width: 45%;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

/** Cocktail Admin Panel **/

#js {
  position: fixed;
  left: 0;
  top: 0;
  width: 5px;
  height: 5px;
  background-color: rgba(248,249,250,1);
  border: none;
}

#spotify-link {
  background:none!important;
  color:rgb(0,196,85) !important;
}

.nav-btn-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.navbar {
  flex-wrap: nowrap !important;
}

/** Media Queries **/

@media (max-width: 865px) {
  .btn-non-controls {
    font-size: calc(12px + 0.25vw) !important;
  }

  #artist-search {
    min-width: auto !important;
    display: inline !important;
    font-size: calc(8px + 0.25vw) !important;
  }

  #submit-btn {
    font-size: 15px !important;
    text-align: center;
    justify-self: auto;
  
  }
  #search-form-group {
    margin-bottom: 0 !important;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
  }

  .nav-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;;AAEd;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,4CAA4C;EAC5C,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,4CAA4C;EAC5C,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA,iBAAiB;;AAEjB;EACE,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA,iBAAiB;AACjB,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA,mBAAmB;;AAEnB;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,SAAS;AACX;;;AAGA,qBAAqB;;AAErB;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA,uBAAuB;;AAEvB;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;;AAEpB;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;;EAEpB;EACA;IACE,2BAA2B;IAC3B,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: auto;\n  padding: 0;\n}\n\nhtml, body {\n  height: 100%;\n}\n\nbody {\n  background-color: rgba(0,0,0,1);\n  color: #eee;\n  font-family: Helvetica, Arial;\n  font-size: 3vmin;\n}\n\nfooter {\n  background-color: rgba(0,0,0,1) !important;\n  color: #eee !important;\n  font-family: Helvetica, Arial !important;\n  font-size: calc(10px + 2vmin) !important;\n  border-top: 2px solid #eee !important;\n  padding: 2vw !important;\n  max-width: 100% !important;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  pointer-events: none;\n  width: 150px;\n}\n\n.App-header {\n  background-color: rgba(0,0,0,1);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.smSpotifyLogo {\n  width: 17vw;\n}\n\n.lgSpotifyLogo {\n  width: 22vw;\n}\n\ntextarea {\n  height: 40vw !important;\n  width: 40vw !important;\n  font-size: 2vw !important;\n  vertical-align:text-top !important;\n  margin-right: 5vw !important; \n}\n\ninput {\n  width: 40vw !important;\n  font-size: 2vw !important;\n  vertical-align:text-top !important;\n}\n\n.hidden {\n  display: none;\n}\n\n/** Buttons **/\n\n.btn {\n  background-color: transparent !important;\n  border-radius: 2em !important;\n  border: 0.2em solid rgb(0,196,85) !important;\n  color: rgb(0,196,85) !important;\n  cursor: pointer !important;\n  font-size: 3vmin !important;\n  padding: 1em 1.5em !important;\n  text-transform: uppercase !important;\n  transition: all 0.25s ease !important;\n  text-decoration: none !important;\n  font-weight: 700 !important;\n  min-height: 50px !important;\n  outline: none;\n}\n\n.btn:hover .audio-control-icon,\n.btn:active .audio-control-icon {\n  fill: black;\n}\n\n.btn-non-controls {\n  background-color: transparent !important;\n  border-radius: 2em !important;\n  border: 0.2em solid rgb(0,196,85) !important;\n  color: rgb(0,196,85) !important;\n  cursor: pointer !important;\n  font-size: 3vmin !important;\n  text-transform: uppercase !important;\n  transition: all 0.25s ease !important;\n  text-decoration: none !important;\n  font-weight: 700 !important;\n  min-height: 50px !important;\n  margin: 1em 1em !important;\n}\n\n.btn-sm {\n  font-size: 2vmin !important;\n  margin: 0 !important;\n}\n\n.btn:hover {\n  background: rgb(0,196,85) !important;\n  color: rgba(0,0,0,0.8) !important;\n  font-weight: 700 !important;\n}\n\n.favoriteBtnDiv {\n  padding: 2vw;\n  padding-right: 5vw;\n}\n\n.favoriteBtn {\n  width: 8vw;\n  cursor: pointer;\n}\n\n.cocktailPairingDiv {\n  position: relative;\n  padding: 5vw 0 0 20vw;\n  width: 47vw;\n  float: left;\n  text-align: center;\n}\n\n#curCocktailDivGroup {\n  width: 100% !important;\n}\n\n#navlink-login-btn {\n  display: table-cell !important;\n  vertical-align:middle !important;\n  height: 50px !important;\n  width: 218px !important;\n}\n\n#navlink-login-btn:hover {\n  background: rgb(0,196,85) !important;\n  color: rgba(0,0,0,0.8) !important;\n  font-weight: 700 !important;\n}\n\n/** Background **/\n\n.background {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center center;\n  filter: blur(8em) opacity(0.6);\n}\n\n.main-wrapper {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  margin: 0 auto;\n  justify-content: center;\n  position: relative;\n  width: 80%;\n  z-index: 1;\n  font-size: 0.7em;\n}\n\n.container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n}\n\n.main-container {\n  flex: 1;\n}\n\n/** Player CSS **/\n/** Now Playing **/\n.now-playing {\n  max-width: 500px;\n}\n\n.now-playing__name {\n  font-size: 1.5em;\n  margin-bottom: 0.2em;\n}\n\n.now-playing__artist {\n  font-size: 1.2em;\n  margin-bottom: 1em;\n}\n\n.now-playing__device-select {\n  font-size: 1.2em;\n  margin-bottom: 0.25em;\n}\n.now-playing__device-select select {\n  width: 35vw;\n  cursor: pointer;\n}\n\n.now-playing__status {\n  font-size: 1.2em;\n  margin-bottom: 1em;\n}\n\n.now-playing__img {\n  float: left;\n  margin-right: 10px;\n  text-align: right;\n  width: 45%;\n}\n\n.now-playing__img img {\n  min-width: 20vmin;\n  max-width: 80vmin;\n  width: 100%;\n}\n\n.now-playing__side {\n  margin-left: 5%;\n  width: 45%;\n}\n\n/** Progress Bar **/\n\n.progress {\n  border: 1px solid #eee;\n  height: 6px;\n  width: 35vw;\n  /* margin: 0; */\n  margin-left: 0.5vw;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.progress__bar {  \n  background-color: rgba(0,0,0,0.8);\n  height: 16px;\n  margin: 0;\n}\n\n\n/** Navbar Styling **/\n\nNavbarBrand {\n  vertical-align: bottom;\n}\n\n#artist-search {\n  min-width: 34vh !important;\n  display: inline !important;\n}\n\n.search-form {\n  display: inline !important;\n}\n\n#search-submit {\n  width: 100%;\n}\n\n/** Text box styling **/\n\n.normal-text {\n  max-width: 575px;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\nh3 {\n  margin: 7vh !important;\n}\n\n\n/** Cocktail styling **/\n\n.cocktail__img {\n  float: right;\n  margin-left: 10px;\n  text-align: left;\n  width: 45%;\n}\n\n.cocktail__img img {\n  min-width: 20vmin;\n  max-width: 80vmin;\n  width: 100%;\n}\n\n.cocktail__directions {\n  white-space: pre-wrap !important;\n  margin-bottom: 0.2em;\n}\n\n.cocktail__side {\n  margin-left: 5%;\n  width: 45%;\n}\n\n.clearfix::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n\n/** Cocktail Admin Panel **/\n\n#js {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 5px;\n  height: 5px;\n  background-color: rgba(248,249,250,1);\n  border: none;\n}\n\n#spotify-link {\n  background:none!important;\n  color:rgb(0,196,85) !important;\n}\n\n.nav-btn-container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.navbar {\n  flex-wrap: nowrap !important;\n}\n\n/** Media Queries **/\n\n@media (max-width: 865px) {\n  .btn-non-controls {\n    font-size: calc(12px + 0.25vw) !important;\n  }\n\n  #artist-search {\n    min-width: auto !important;\n    display: inline !important;\n    font-size: calc(8px + 0.25vw) !important;\n  }\n\n  #submit-btn {\n    font-size: 15px !important;\n    text-align: center;\n    justify-self: auto;\n  \n  }\n  #search-form-group {\n    margin-bottom: 0 !important;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100%;\n  }\n\n  .nav-btn-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
